/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_CodeInputs */

const vi_grower_area_public_code = /** @type {(inputs: Grower_Area_Public_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã vùng trồng`)
};

/**

* @param {Grower_Area_Public_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_code = /** @type {((inputs?: Grower_Area_Public_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_code(inputs)
});